/** Matches לקוח / לקוחות / לקוחות בישראל / לקוחות בחו"ל / etc. */
export const CLIENT_PAL_CODE_SUBSTRING = 'לקוח';

/** Matches ספק / ספקים / etc. */
export const SUPPLIER_PAL_CODE_SUBSTRING = 'ספק';

export const isClientPalCode = (palCode) =>
    String(palCode ?? '').includes(CLIENT_PAL_CODE_SUBSTRING);

export const isSupplierPalCode = (palCode) =>
    String(palCode ?? '').includes(SUPPLIER_PAL_CODE_SUBSTRING);

export const isClientOrSupplierPalCode = (palCode) =>
    isClientPalCode(palCode) || isSupplierPalCode(palCode);

/**
 * Client picker filter for invoice/receipt/delivery-note account cards.
 * - Always keeps the "Add customer" option (value1 === 'AddItem')
 * - Always keeps the currently selected card (so Autocomplete can display it)
 * - Default: palCode contains "לקוח" (mode: 'clients')
 * - mode 'clientsAndSuppliers': palCode contains "לקוח" or "ספק"
 * - showAll:
 *   - clients: previous invoice behavior (editable cards only)
 *   - clientsAndSuppliers: previous movement-form behavior (all cards)
 */
export const shouldIncludeClientAccountCard = (
    option,
    { showAll = false, selectedCardId = null, mode = 'clients' } = {}
) => {
    if (!option) return false;
    if (option.value1 === 'AddItem') return true;

    const cardId = option.cardId ?? option.CardId ?? option.value;
    if (
        selectedCardId != null &&
        selectedCardId !== '' &&
        String(cardId) === String(selectedCardId)
    ) {
        return true;
    }

    if (showAll) {
        if (mode === 'clientsAndSuppliers') {
            return true;
        }
        return option.isEditable === true;
    }

    const palCode = option.palCode ?? option.PalCode;
    if (mode === 'clientsAndSuppliers') {
        return isClientOrSupplierPalCode(palCode);
    }

    return isClientPalCode(palCode);
};
